<template>
  <div class="card shadow bg-secondary">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
        <div class="col text-right">
          <base-button type="primary" size="sm" @click="addNewAgent"
            >บันทึก</base-button
          >
        </div>
      </div>
    </div>

    <div class="card-body pt-0 pt-md-4">
      <div class="row">
        <div class="col-md-2">
          <base-input
            alternative=""
            label="รหัสตัวแทน"
            placeholder="รหัสตัวแทน"
            input-classes="form-control-alternative"
            v-model="model.code"
          />
        </div>
        <div class="col-md-10">
          <base-input
            alternative=""
            label="ชื่อตัวแทน"
            placeholder="ชื่อตัวแทน"
            input-classes="form-control-alternative"
            v-model="model.name"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <base-input
            alternative=""
            label="Username"
            placeholder="Username"
            input-classes="form-control-alternative"
            v-model="model.email"
          />
        </div>
        <div class="col-md-6">
          <base-input
            alternative=""
            label="Password"
            placeholder="Password"
            type="password"
            input-classes="form-control-alternative"
            v-model="model.password"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import router from "../router";
import kickMixin from "../mixins/kickMixin";

export default {
  name: "add-new-agent",
  mixins: [kickMixin],
  components: {},
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      model: {
        code: "",
        email: "",
        password: "",
        name: "",
      },
    };
  },
  methods: {
    addNewAgent: function() {
      var localApp = this;
      axios
        .post("/api/agent", localApp.model, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            router.push("/agent");
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
  },
};
</script>
<style></style>
